import { css, cva, cx } from "styled-system/css";

export type BreakdownColor =
  | "yellow.500"
  | "amber.500"
  | "cream.200"
  | "lilac.100"
  | "light.500"
  | "green.150"
  | "red.100";

export interface BreakdownSegment {
  key: string;
  usd: number;
  color: BreakdownColor;
}

interface BreakdownBarProps {
  segments: BreakdownSegment[];
}

export function BreakdownBar({ segments }: BreakdownBarProps) {
  const positive = segments.filter((s) => s.usd > 0);

  return (
    <div className={trackStyles}>
      {positive.map((s, i) => (
        <div
          key={s.key}
          className={cx(colorBg({ color: s.color }), i < positive.length - 1 && segmentDivider)}
          style={{ flexGrow: s.usd, flexBasis: 0 }}
        />
      ))}
    </div>
  );
}

export function BreakdownDot({ color, disabled }: { color: BreakdownColor; disabled?: boolean }) {
  return <div className={cx(dotBase, disabled ? disabledDotBg : colorBg({ color }))} />;
}

const colorBg = cva({
  variants: {
    color: {
      "yellow.500": { bg: "yellow.500" },
      "amber.500": { bg: "amber.500" },
      "cream.200": { bg: "cream.200" },
      "lilac.100": { bg: "lilac.100" },
      "light.500": { bg: "light.500" },
      "green.150": { bg: "green.150" },
      "red.100": { bg: "red.100" },
    },
  },
});

const trackStyles = css({
  display: "flex",
  w: "full",
  h: "8",
  rounded: "full",
  bg: "background.tertiary",
  overflow: "hidden",
});

const dotBase = css({ w: "8", h: "8", rounded: "full", flexShrink: 0 });
const disabledDotBg = css({ bg: "text.disabled" });
const segmentDivider = css({
  borderRightWidth: "100",
  borderRightStyle: "solid",
  borderRightColor: "background.canvas",
});
